import HNY2024 from './HNY2024';
import SystemSlowApologize from './SystemSlowApologize';

export { HNY2024, SystemSlowApologize };
export default { HNY2024, SystemSlowApologize };
